import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import { Box, Grid, Typography } from "@mui/material";
import { format, parse } from "date-fns";
import { useContext } from "react";
import { AppContext } from "../../../context";

export default function EwqLeadInfo() {
  const { lead } = useContext<any>(AppContext);
  const cpf = lead.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  const birthday = format(
    parse(lead.birthday, "yyyy-MM-dd", new Date()),
    "dd/MM/yyyy"
  );
  return (
    <Grid
      container
      direction="column"
      sx={{
        height: "100%",
        width: 330,
        border: 2,
        borderColor: "primary.main",
        borderRadius: 3,
        alignItems: "center",
        justifyContent: "flex-start",
        margin: "auto",
      }}
    >
      <Box sx={{ margin: "10px auto" }}>
        <Typography
          variant="body2"
          color="primary.main"
          sx={{ fontWeight: "bold", mt: 1, fontSize: "1.1rem" }}
        >
          Seus Dados
        </Typography>
      </Box>
      <Box
        sx={{
          width: "80%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <AccountCircleOutlinedIcon
            sx={{ color: "primary.main", mr: 1, mb: 1 }}
          />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.name}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ArticleOutlinedIcon sx={{ color: "primary.main", mr: 1, mb: 1 }} />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {cpf}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CalendarTodayOutlinedIcon
            sx={{ color: "primary.main", mr: 1, mb: 1 }}
          />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {birthday}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <MapOutlinedIcon sx={{ color: "primary.main", mr: 1, mb: 1 }} />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.address_cep}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <HomeOutlinedIcon sx={{ color: "primary.main", mr: 1, mb: 1 }} />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.address_street}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PinDropOutlinedIcon sx={{ color: "primary.main", mr: 1, mb: 1 }} />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.address_number}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <AlternateEmailOutlinedIcon
            sx={{ color: "primary.main", mr: 1, mb: 1 }}
          />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.email}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LocalPhoneOutlinedIcon
            sx={{ color: "primary.main", mr: 1, mb: 1 }}
          />
          <Typography
            variant="body2"
            color="primary.main"
            sx={{ fontSize: "1rem", mb: 1 }}
          >
            {lead.cellphone}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
}
